import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '@docpath/linces-angular-components/common';
import { mergeMap, Observable, of } from 'rxjs';
import { RoutingPath } from 'src/app/constants/routing-path';

import { CloudService } from '../services/cloud.service';

@Injectable({
    providedIn: 'root'
})
export class LoginGuard implements CanActivate {

    private readonly loginService = inject(LoginService);
    private readonly cloudService = inject(CloudService);

     
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {

        if (this.cloudService.isModeCloud()) {
            this.loginService.checkSessionByToken(
                this.cloudService.getAccessTokenCookie(),
                this.cloudService.getRefreshTokenCookie(),
                state.url,
                `/${RoutingPath.PATH_LOGIN}`
            ).pipe(
                mergeMap(returnCheckSession => {
                    this.cloudService.updateCookies();

                    return of(returnCheckSession);
                })
            );
        }

        return this.loginService.checkSession(state.url, `/${RoutingPath.PATH_LOGIN}`);

    }

}
